module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "help"
  }, [_c('p', {
    staticClass: "help-con"
  }, [_vm._v("©️58帮助中心")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0cc63363"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/index/modules/help/Help.vue
// module id = DrUF
// module chunks = 1